/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseTicketCategory } from '../../models/api-response-ticket-category';

export interface GetByRef$Params {
  ref: string;
}

export function getByRef(http: HttpClient, rootUrl: string, params: GetByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTicketCategory>> {
  const rb = new RequestBuilder(rootUrl, getByRef.PATH, 'get');
  if (params) {
    rb.path('ref', params.ref, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseTicketCategory>;
    })
  );
}

getByRef.PATH = '/v1/api/admin-ui/category-ticket/get/{ref}';
